/**
 * Safe storage helper to prevent crashes when localStorage/sessionStorage is blocked (e.g. Incognito mode)
 */
const getStorage = (type) => {
    try {
        const s = window[type + 'Storage'];
        // Test if storage is actually writable
        const testKey = '__storage_test__';
        s.setItem(testKey, testKey);
        s.removeItem(testKey);
        return s;
    } catch (e) {
        return null;
    }
};

const localStorage = getStorage('local');
const sessionStorage = getStorage('session');

function safelyUseStorage(storage, fallback, callback) {
    if (!storage) return fallback;

    try {
        return callback(storage);
    } catch (e) {
        return fallback;
    }
}

export const safeStorage = {
    local: {
        get: (key) => safelyUseStorage(localStorage, null, (storage) => storage.getItem(key)),
        set: (key, value) => safelyUseStorage(localStorage, undefined, (storage) => storage.setItem(key, value)),
        remove: (key) => safelyUseStorage(localStorage, undefined, (storage) => storage.removeItem(key)),
    },
    session: {
        get: (key) => safelyUseStorage(sessionStorage, null, (storage) => storage.getItem(key)),
        set: (key, value) => safelyUseStorage(sessionStorage, undefined, (storage) => storage.setItem(key, value)),
        remove: (key) => safelyUseStorage(sessionStorage, undefined, (storage) => storage.removeItem(key)),
    }
};

window.growtypeSafeStorage = safeStorage;
